import React, { useEffect, useState } from 'react';
import { FaRegStar, FaSitemap } from 'react-icons/fa';
import Button from '../ui/Button';
import './../../styles/SupportDashboard.css';
import './../../styles/FavouriteDeviceModal.css';

const EMPTY_FORM = {
  notes: '',
};

export default function FavouriteDeviceModal({ isOpen, user, initialValue, onClose, onSave }) {
  const [formState, setFormState] = useState(EMPTY_FORM);

  useEffect(() => {
    if (!isOpen) return;

    setFormState({
      notes: initialValue?.notes || '',
    });
  }, [initialValue, isOpen]);

  if (!isOpen || !user) return null;

  const handleSubmit = () => {
    onSave({
      isFavourite: true,
      notes: formState.notes.trim(),
    });
  };  

  return (
    <div className="sd-modal-backdrop favourite-modal-overlay" role="dialog" aria-modal="true">
      <div className="sd-modal sd-modal-md favourite-modal">
        <div className="sd-modal-header favourite-modal-header">
          <div>
            <h2 className="sd-title">Visor Reference</h2>
            <div className="sd-subtitle">
              Save this visor to favourites to track it easily in Incidents.
            </div>
          </div>
          <button className="sd-icon-btn" onClick={onClose} aria-label="Close" type="button">
            x
          </button>
        </div>

        <div className="sd-modal-body favourite-modal-body">
          <div className="sd-label">Device Details</div>
          <div className="favourite-device-card">
            <div className="favourite-device-avatar">
              <FaRegStar />
            </div>
            <div className="favourite-device-info">
              <h3>{user.visorId || 'Unknown visor'}</h3>
              <span><FaSitemap /> {user.groupName || 'Unknown group'}</span>
            </div>
          </div>

          <div className="sd-field">
            <div className="sd-label">Notes</div>
            <textarea
              className="sd-textarea favourite-notes-textarea"
              rows="5"
              placeholder="Add any notes for this favourite"
              value={formState.notes}
              onChange={(event) =>
                setFormState((prev) => ({ ...prev, notes: event.target.value }))
              }
            />
          </div>
        </div>

        <div className="sd-modal-footer favourite-modal-footer">
          {initialValue?.isFavourite && (
            <Button
              type="button"
              buttonStyle="btn-alternate"
              onClick={() => onSave({ isFavourite: false, notes: '' })}
            >
              Unset Favourite
            </Button>
          )}
          <Button onClick={onClose} buttonStyle="btn-alternate">
            Cancel
          </Button>
          <Button onClick={handleSubmit}>
            Save Favourite
          </Button>
        </div>
      </div>
    </div>
  );
}
